import type { Node, NodeProps } from '@xyflow/react';
import { ZfLoadingSpinner, ZfTextButton } from '@zafire/react';
import { type FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useClient } from '../../../app/api';
import { useWealthPlanningNavigate } from '../../../app/hooks/useWealthPlanningNavigate';
import type { PartnerNodeData } from '../../interfaces';
import { PreselectedRelationshipType } from '../../types/PartnerRelation';
import { CreatePartnerRelationModal } from '../partner-data/CreatePartnerRelationModal';
import { PartnerNode } from './partner-node';

type NoRelationsNodeType = Node<PartnerNodeData, 'familyTreeNode'>;

export const NoRelationsNode: FunctionComponent<NodeProps<NoRelationsNodeType>> = (props) => {
    const { t } = useTranslation();
    props.data.showAddIcons = false;
    props.data.showHideIcon = false;

    const { partnerUuid } = useWealthPlanningNavigate();
    const { data: partner } = useClient(partnerUuid);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

    if (!partner) return <ZfLoadingSpinner />;

    return (
        <div className="no-relations-node">
            <div style={{ width: 'fit-content' }}>
                <PartnerNode {...props} />
            </div>
            {!props.data.isPrintMode && (
                <div className="no-relations-node-text">
                    <h2 className="no-relations-node-title">{t('familyTreeNoRelationsNodeTitle')}</h2>
                    <span className="no-relations-node-description">{t('familyTreeNoRelationsNodeDescription')}</span>
                    <ZfTextButton hierarchy="secondary" size="medium" leadingIcon="add_circle" onClick={() => setIsModalOpen(true)}>
                        {t('familyTreeNoRelationsNodeButton')}
                    </ZfTextButton>
                    {isModalOpen && (
                        <CreatePartnerRelationModal
                            partnerUuid={partnerUuid}
                            sourceRelations={[{ partnerUuid: partnerUuid, fullName: partner.fullName! }]}
                            availablePartners={[]}
                            onModalClose={() => setIsModalOpen(false)}
                            preselectedRelationshipType={PreselectedRelationshipType.IS_PARENT}
                            relationshipManagerUserId={partner.relationshipManager?.userId}
                        />
                    )}
                </div>
            )}
        </div>
    );
};
